// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const UpdateLayoutModalFooter = props =>
    <div className='layout-modal-footer'>
        <button onClick={props.onCancel}>
            <FormattedMessage id='CANCEL'/>
        </button>
        <button onClick={props.onDelete}>
            <FormattedMessage id='REMOVE_LAYOUT'/>
        </button>
        <button
            className='button-primary'
            onClick={props.onSave}
        >
            <FormattedMessage id='SAVE'/>
        </button>
    </div>;

UpdateLayoutModalFooter.displayName = 'UpdateLayoutModalFooter';
UpdateLayoutModalFooter.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
};

export default UpdateLayoutModalFooter;



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-variant-modals/update-layout-modal/update-layout-modal-footer.js